import { BefGlobalService, BefMetaData, BefMetaDataService, BefPageService } from "@beflam/bef-core";
import { BefPluginProxyDataService } from "./bef-plugin-proxy-data-service";

export class BefPluginService {
    private proxyService: any = {}; //不暴露出来，这个是作为在SourceCode中的代理类使用的
    constructor(private metaDataService: BefMetaDataService, private pageService: BefPageService, private globalService: BefGlobalService) {

    }
    saveUIBuilderParameter(params: any) {
        BefPluginProxyDataService.notifySave(params);
    }
    changeParameter(params: any) {
        BefPluginProxyDataService.notifyChange(params);
    }
    createPageProxy() {
        const pageInstance: BefPluginService = this;
        const uiBuilder: any = {};
        uiBuilder.saveParameter = (params: any): any => {
            return pageInstance.saveUIBuilderParameter(params);
        };
        Object.defineProperty(this.proxyService, "uiBuilder", {
            get: function () {
                return uiBuilder;
            }
        });
        Object.defineProperty(this.proxyService, "saveParameter", {
            get: function () {
                return (pageInstance.pageService.page as any)["pluginParamSaveEventEx"];
            },
            set: function (val) {
                (pageInstance.pageService.page as any)["pluginParamSaveEventEx"] = val;
            }
        });
        Object.defineProperty(this.proxyService, "settingChanged", {
            get: function () {
                return (pageInstance.pageService.page as any)["pluginParamChangedEvent"];
            },
            set: function (val) {
                (pageInstance.pageService.page as any)["pluginParamChangedEvent"] = val;
            }
        });
        this.proxyService.getTableViewList = (): any => {
            return new Promise((resolve, reject) => {
                if (!this.pageService.page) reject("页面加载错误：page为空");
                try {
                    pageInstance.metaDataService.GetValues(this.pageService.page.appID, "@@TABLEVIEW", null, this.globalService.session.id, false, resolve);
                } catch (err) {
                    reject(err);
                }
            });
        };
        this.proxyService.getFieldList = (tableView: string): any => {
            return new Promise((resolve, reject) => {
                if (!this.pageService.page) reject("页面加载错误：page为空");
                try {
                    pageInstance.metaDataService.GetValues(this.pageService.page.appID, `@@FIELD_${tableView}`, null, this.globalService.session.id, false, resolve);
                } catch (err) {
                    reject(err);
                }
            });
        };
        this.proxyService.getEntitySchemaList = (): any => {
            return new Promise(async (resolve, reject) => {
                if (!this.pageService.page) reject("页面加载错误：page为空");
                try {
                    const data = await this.pageService.callRPC("Beflam.Framework", "Beflam.Framework.Service.AppItemService", "GetAppItems", { appId: this.pageService.page.appID, appItemType: "ENTITYSCHEMA" });
                    const result = new BefMetaData();
                    result.Data = [];
                    for (let key in data) {
                        result.Data.push({ value: key, label: data[key] });
                    }
                    result.DisplayFields = "value,label";
                    result.ValueField = "value";
                    resolve(result);
                } catch (err) {
                    reject(err);
                }
            });
        };
        this.proxyService.showIframeDialog = (url: string, title: string, cb?: () => void) => {
            let i18n = {
                "zh-CN": {},
                "en-US": {}
            };
            let pageSchema = {
                id: "node_page",
                componentName: "Page",
                props: {
                    ref: "outerView",
                    style: {
                        position: "absolute",
                        height: "100%",
                        width: "100%"
                    }
                },
                children: [{
                    id: "node_iframe",
                    componentName: "BefIframe",
                    props: {
                        url: url,
                        style: {
                            width: '100%',
                            height: '100%',
                            border: 'none'
                        }
                    },
                    children: [],
                    isLocked: false,
                    title: "",
                    ignore: false,
                    hidden: false,
                    condition: true,
                    conditionGroup: "",
                    defaultProps: null
                }],
                isLocked: false,
                title: "",
                ignore: false,
                hidden: false,
                condition: true,
                conditionGroup: "",
                defaultProps: null
            };
            let np = this.pageService.createPage(`iframe_${url}`, "DEF");
            np.title = title;
            np.isPreview = true;
            np.renderSchema = { ChildrenSchema: { componentsTree: [pageSchema], i18n }, DataSourceData: [] };
            this.pageService.showDialog(np, cb);
        }
        this.proxyService.changeSetting = (data: any) => {
            pageInstance.changeParameter(data);
        }
        return this.proxyService;
    }
}